export default "__VITE_ASSET__DSBkGrgy__"